export const croPerfomanceAnalyticsTableHeader = [
  {
    field: 'slNo',
    headerName: 'Sl No',
    width: 80,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'cro',
    headerName: 'CRO',
    width: 140,
    sortable: false,
  },
  {
    field: 'activeStudentsFromDate',
    headerName: 'Active Students (From Date)',
    width: 200,
    sortable: false,
  },
  {
    field: 'payingStudents',
    headerName: 'Paying Students',
    width: 150,
    sortable: false,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'activeTutorsFromDate',
    headerName: 'Active Tutors (From Date)',
    width: 200,
    sortable: false,
  },
  {
    field: 'studentTutorRatio',
    headerName: 'Student Tutor Ratio',
    width: 180,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'revenue',
    headerName: 'Revenue',
    width: 140,
    sortable: false,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'arpu',
    headerName: 'ARPU',
    width: 120,
    sortable: false,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'arppu',
    headerName: 'ARPPU',
    width: 120,
    sortable: false,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'totalTp',
    headerName: 'Total TP',
    width: 120,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'sessionsHeld',
    headerName: 'Sessions Held',
    width: 150,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'averageTp',
    headerName: 'Average TP',
    width: 140,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'payingStudentRate',
    headerName: 'Paying Student Rate',
    width: 180,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'tcUploads',
    headerName: 'TC Uploads',
    width: 130,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'reactivations',
    headerName: 'Reactivations',
    width: 150,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'tcsFromInactive',
    headerName: 'TCs from Inactive',
    width: 180,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
];
